import Vue from 'vue'
import App from './App.vue'
import router from './router'
import "./assets/css/reset.css"//初始化css
import "./assets/css/flex.css"
import "./assets/css/globalVariable.less"//全局样式配置文件

import VueCookies from 'vue-cookies'
import store from './store/index.js'
Vue.use(VueCookies)
//手机端适配
// import { rem } from './utils/rem'
// rem(document, window, 750)
// import Vant from 'vant';
// import 'vant/lib/index.css';
// import { Tab, Tabs, Popup, Dialog, Toast } from 'vant';
// Vue.use(Vant);
// Vue.use(Tab, Tabs, Popup, Dialog, Toast );
//PC端适配
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

Vue.config.productionTip = false
new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
